<template>
  <div>
    <b-form @submit.prevent="salvar" autocomplete="off">
      <div class="row">
        <div class="col">
          <fcc-input v-model="titulo" required>Título</fcc-input>
        </div>
        <div class="col">
          <fcc-select :options="solicitantes" v-model="solicitante" required
            >Solicitante</fcc-select
          >
        </div>
        <div class="col">
          <fccDateInput type="datetime" required v-model="dtInicio">Data de Início</fccDateInput>
        </div>
        <div class="col">
          <fccDateInput type="datetime" required v-model="dtEntrega">Data de Entrega</fccDateInput>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <fcc-select :options="sistemas" v-model="sistema" required>Sistema</fcc-select>
        </div>
        <div class="col">
          <fcc-select :options="situacoesProjeto" v-model="situacao" required>Situação</fcc-select>
        </div>
        <div class="col">
          <fcc-select :options="equipes" v-model="equipesSelecionadas" required multiple
            >Equipe</fcc-select
          >
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <label class="h5">Detalhes</label>
          <fcc-editor v-model="detalhe" :limpar-html="true"></fcc-editor>
        </div>
      </div>
      <div class="row my-2">
        <div class="col text-right">
          <fcc-button tipo="submit">{{ projectId ? 'Alterar' : 'Salvar' }}</fcc-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import { mapState } from 'vuex'

export default {
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      idProjeto: 0,
      titulo: '',
      solicitante: '',
      dtInicio: '',
      dtEntrega: '',
      sistema: null,
      situacao: null,
      equipesSelecionadas: null,
      detalhe: '',
      quantidadeMaximaCaracteres: 4000
    }
  },
  computed: {
    titlePage() {
      return 'Adicionar projeto'
    },
    ...mapState('acompanhamentoDeProjetos', [
      'solicitantes',
      'equipes',
      'sistemas',
      'situacoesProjeto',
      'projeto'
    ]),
    detalheHtmlLimpo() {
      const htmlLimpo = this.detalhe
        .replace(/<!--.*?-->/gs, '')
        .replace(/\s?(style|class|id|lang|width|height|align)=(".*?"|'.*?')/gi, '')
        .replace(/<(ul|ol)[^>]*>/gi, (tag) => (tag.match(/<ul/i) ? '<ul>' : '<ol>'))
        .replace(/<\/?span[^>]*>/gi, '')
        .replace(/<\/?font[^>]*>/gi, '')
        .replace(/<p[^>]*>(?:\s|&nbsp;|\n|\r|\t)*<br\s*\/?>(?:\s|&nbsp;|\n|\r|\t)*<\/p>/gi, '<br>')
        .replace(/<li>(\s|&nbsp;|<br\s*\/?>)*<\/li>/gi, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s{2,}/g, ' ')
        .replace(/>\s+</g, '><')
        .replace(/\n|\r|\t/g, '')
        .trim()

      const textarea = document.createElement('textarea')
      textarea.innerHTML = htmlLimpo
      return textarea.value
    }
  },
  watch: {
    projeto(value) {
      if (value) {
        this.idProjeto = value.idprojeto
        this.titulo = value.descricao
        this.solicitante = this.solicitantes.find(
          (item) =>
            item?.usuariocomplemento?.usucompcdfuncionario === value.cdfuncionariosolicitante
        )
        this.dtInicio = value.dtinicio
        this.dtEntrega = value.dtentrega
        this.sistema = this.sistemas.find((item) => item.idsistema === value.idsistema)
        this.situacao = this.situacoesProjeto.find(
          (item) => item.tpsituacaoprojeto === value.tpsituacaoprojeto
        )
        this.equipesSelecionadas = value.equipes
        this.detalhe = value.detalhe
      }
    }
  },
  methods: {
    salvar() {
      this.callConfirm(
        this.projectId ? 'Deseja alterar o projeto?' : 'Deseja salvar o projeto?',
        ''
      ).then((result) => {
        if (result.value) {
          const salvar = this.projectId ? this.alterarCompleto : this.adicionarProjeto

          this.carregaTexto(this.codeMensagem('C01'))
          salvar()
            .then((data) => {
              this.carregaTexto()

              if (this.projectId) {
                this.callToast(this.mensagensUpdate.editado, 'success')
              } else
                this.$router.push({
                  path: '/acompanhamento-projetos/editar-projeto/' + data.data
                })
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    alterarCompleto() {
      const payload = {
        idProjeto: this.idProjeto,
        descricao: this.titulo,
        detalhe: this.detalheHtmlLimpo,
        cdFuncionarioSolicitante: this.solicitante?.usuariocomplemento?.usucompcdfuncionario,
        tpSituacaoProjeto: this.situacao.tpsituacaoprojeto,
        idSistema: this.sistema.idsistema,
        dtInicio: this.dtInicio,
        dtEntrega: this.dtEntrega,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        equipes: this.equipesSelecionadas.map((equipe) => ({
          idEquipe: equipe.idequipe,
          descricao: equipe.descricao,
          cdFuncionario: equipe.cdfuncionario
        }))
      }

      return new Promise((resolve, reject) => {
        axios
          .put(
            store.state.baseUrlGestaoProjetos + 'Projeto/AlterarCompleto',
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => resolve(data))
          .catch(reject)
      })
    },
    adicionarProjeto() {
      const payload = {
        idProjeto: 0,
        descricao: this.titulo,
        detalhe: this.detalheHtmlLimpo,
        cdFuncionarioSolicitante: this.solicitante?.usuariocomplemento?.usucompcdfuncionario,
        tpSituacaoProjeto: this.situacao.tpsituacaoprojeto,
        idSistema: this.sistema.idsistema,
        dtInicio: this.dtInicio,
        dtEntrega: this.dtEntrega,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        equipes: this.equipesSelecionadas.map((equipe) => ({
          idEquipe: equipe.idequipe,
          descricao: equipe.descricao,
          cdFuncionario: equipe.cdfuncionario
        }))
      }

      return new Promise((resolve, reject) =>
        axios
          .post(
            store.state.baseUrlGestaoProjetos + 'Projeto/AdicionarCompleto',
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
          .catch(reject)
      )
    }
  }
}
</script>